// The accents an agent can speak English with, stored as config.language (owner,
// 2026-10-18; shared/agent-models.json, which accents.test.ts holds this file to).
// The bot sends Gemini every one but the default as its language code, on 3.8 Live
// and on a text model's voice alike; the default, "en", sends none, which Gemini
// speaks as American. The code sets the accent; a prompt barely moves it.
export const ACCENTS = ["en", "en-IN"] as const;
export type Accent = (typeof ACCENTS)[number];
export const DEFAULT_ACCENT: Accent = "en";

export const ACCENT_LABELS: Record<Accent, string> = {
  en: "American (default)",
  "en-IN": "Indian",
};

/** The line under the Accent dropdown. */
export const ACCENT_HELP = "How the agent sounds when it speaks English. Indian also suits agents that speak Hindi or Hinglish.";

/**
 * A stored config.language as the dropdown shows it, read as the bot reads it
 * (case and surrounding spaces ignored). Any other value — none, "es", a typo —
 * shows as the default; Publish keeps it unless the accent is changed.
 */
export const accentOf = (language: unknown): Accent => {
  const code = typeof language === "string" ? language.trim().toLowerCase() : "";
  return ACCENTS.find((accent) => accent.toLowerCase() === code) ?? DEFAULT_ACCENT;
};
